import React, { useState } from "react";
import "../CSS/AboutSection.css";

const AboutSection = () => {

    const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, mobile, message } = formData;

    const whatsappNumber = "916393244687";

    const text = `New Enquiry:%0A
                  Name: ${name}%0A
                  Email: ${email}%0A
                  Mobile: ${mobile}%0A
                  Message: ${message}`;

    const url = `https://wa.me/${whatsappNumber}?text=${text}`;

    window.open(url, "_blank");
  };

  return (
    <section className="about-section">

      <div className="about-container">

        {/* LEFT CONTENT */}

        <div className="about-content">

          <h2>About Apostille Services in India</h2>

          <p>
            Apostille.net.in is a trusted provider of <strong>MEA Apostille and
            Certificate Attestation Services in India</strong>. We help
            individuals and businesses complete the document authentication
            process required for international use. Our expert team provides
            reliable guidance for educational, personal, and commercial
            document attestation.
          </p>

          <p>
            Through the <strong>Automated Document Authentication (ADA)</strong>
            system of the Ministry of External Affairs (MEA), we ensure a fast,
            secure, and transparent apostille process. Our services are
            available across major cities including <strong>Delhi NCR,
            Mumbai, Hyderabad, Kolkata, Chennai, and Bangalore</strong>.
          </p>

          <p>
            Our experienced consultants handle the complete attestation
            procedure and provide accurate documentation support for visa,
            employment, higher education, and international business
            requirements.
          </p>

        </div>

        {/* RIGHT FORM */}

        <div className="enquiry-box">

          <h3>-- ENQUIRY NOW --</h3>

           <form onSubmit={handleSubmit}>

            <input
              type="text"
              name="name"
              placeholder="Name*"
              required
              onChange={handleChange}
            />

            <input
              type="email"
              name="email"
              placeholder="Email*"
              required
              onChange={handleChange}
            />

            <input
              type="tel"
              name="mobile"
              placeholder="Mobile*"
              required
              onChange={handleChange}
            />

            <textarea
              name="message"
              placeholder="Message"
              onChange={handleChange}
            ></textarea>

            <button type="submit">SUBMIT</button>

            <p className="mandatory">*All Fields are Mandatory</p>

          </form>

        </div>

      </div>

    </section>
  );
};

export default AboutSection;